<iframe class="iframe" width="{{width}}" height="{{height}}" class="w-100" [src]="settings.url | url"></iframe>
